export const blockIconsUiactionsExpandLessNew = (
	<span className='material-symbols-outlined'>expand_less</span>
);
